import * as req from 'api/actions';
import * as c from './constant';

export const getList = (payload = {}, callback) =>
  req.list(
    c.LIST,
    'api/v1/administrators/rpt_billing_csv_imports',
    payload,
    callback
  );

export const upload = (payload = {}, callback) =>
  req.upload(
    c.UPLOAD,
    'api/v1/administrators/rpt_billing_csv_imports/upload_csv',
    payload,
    callback
  );

  export const getUploadedList = (payload = {}, callback) =>
  req.list(
    c.UPLOAD_LIST,
    'api/v1/administrators/file_uploads',
    payload,
    callback
  );

  export const showUploaded = (id) =>
  req.item(
    c.SHOW_UPLOADED,
    `api/v1/administrators/file_uploads/${id}`
  );

  export const deleteFileUpload = (id, payload, callback) => 
  req.remove(
    c.DELETE_FILE_UPLOAD,
    `api/v1/administrators/rpt_billing_csv_imports/${id}`,
    payload,
    callback,
  );

  export const deleteFileHistoryUpload = (id, payload, callback) => 
  req.remove(
    c.DELETE_FILE_HISTORY_UPLOAD,
    `/api/v1/administrators/file_uploads/${id}`,
    payload,
    callback,
  );

  // add record
  export const createRecord = (payload, callback) => 
  req.create(
    c.CREATE_RECORD,
    'api/v1/administrators/rpt_billing_csv_imports',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    },
  );
  
  export const updateRecord = (id, payload, callback) => 
  req.update(
    c.UPDATE_RECORD,
    `api/v1/administrators/rpt_billing_csv_imports/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    },
  );

  // for Manual Import API (Smart City | RPTAX)
  export const getListManualImport = (payload = {}, callback) =>
  req.list(
    c.LIST_MANUAL_IMPORT,
    '/api/v1/administrators/rpt_billing_manual_imports',
    payload,
    callback
  );

  export const createRecordManualImport = (payload, callback) => 
  req.create(
    c.CREATE_RECORD_MANUAL_IMPORT,
    'api/v1/administrators/rpt_billing_manual_imports',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    },
  );
  
  export const updateRecordManualImport = (id, payload, callback) => 
  req.update(
    c.UPDATE_RECORD_MANUAL_IMPORT,
    `api/v1/administrators/rpt_billing_manual_imports/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    },
  );

  export const deleteRecordManualImport = (id, payload, callback) => 
  req.remove(
    c.DELETE_RECORD_MANUAL_IMPORT,
    `/api/v1/administrators/rpt_billing_manual_imports/${id}`,
    payload,
    callback,
  );

  
  // for Manual Import API (Smart City | RPTAX - BORONGAN)
  export const getListManualImportBorongan = (payload = {}, callback) =>
  req.list(
    c.LIST_MANUAL_IMPORT,
    '/api/v1/administrators/borongan_rpt_billings',
    payload,
    callback
  );

  export const createRecordManualImportBorongan = (payload, callback) => 
  req.create(
    c.CREATE_RECORD_MANUAL_IMPORT,
    '/api/v1/administrators/borongan_rpt_billings',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    },
  );
  
  export const updateRecordManualImportBorongan = (id, payload, callback) => 
  req.update(
    c.UPDATE_RECORD_MANUAL_IMPORT,
    `/api/v1/administrators/borongan_rpt_billings/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data }); 
    },
  );

  export const updateAmountFeesBorongan = (id, payload, callback) => 
  req.update(
    c.UPDATE_AMOUNT_FEES_BORONGAN,
    `/api/v1/administrators/borongan_rpt_billings/${id}/tax_amount/`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data }); 
    },
  );

  export const deleteRecordManualImportBorongan = (id, payload, callback) => 
  req.remove(
    c.DELETE_RECORD_MANUAL_IMPORT,
    `/api/v1/administrators/borongan_rpt_billings/${id}`,
    payload,
    callback,
  );

  // penalty and discount (Add record)
  export const calculatePenaltyDiscount = (payload, callback) => 
  req.create(
    c.CALCULATE_PENALTY_DISCOUNT,
    '/api/v1/administrators/borongan_rpt_billings/calculate_penalty_discount',
    payload,
    callback,
  );

// **
  // OR NUMBER (Payment records) - BORONGAN SMART CITY
  export const getPaymentList = (payload, callback) =>
  req.list(
    c.GET_PAYMENT_LIST,
    '/api/v1/administrators/real_property_tax_account_registers',
    payload,
    callback
  );

  export const updateORNumber = (id, payload, callback) =>
  req.update(
    c.UPDATE_OR_NUMBER,
    `/api/v1/administrators/borongan_rpt_billings/transactions/${id}/or_number`,
    payload,
    callback
  );

  // view or list  - NO NEED, (UPDATE OR)
  // export const viewPaymentListing = (id, payload, callback) =>
  // req.list(
  //   c.VIEW_PAYMENT_LISTING,
  //   `/api/v1/administrators/real_property_billings/${id}/payments`,
  //   payload,
  //   callback
  // );
